export const CAMPOS = {
    IDENTIFICADOR: 'identificador',
    CODIGO: 'codigo',
};

export const CONTEXTO = {
    ANALISE: {
        caminho: 'analise',
        titulo: 'análise',
    },
    TELECONSULTORIAS: {
        caminho: 'teleconsultorias',
        titulo: 'teleconsultorias',
    },
    EXAME: {
        caminho: 'exame',
        titulo: 'exames',
    },
    TCLE: {
        caminho: 'tcle',
        titulo: 'tcle',
    },
    APAC: {
        caminho: 'apac',
        titulo: 'processos de apac',
    },
    RONDA: {
        caminho: 'ronda',
        titulo: 'rondas',
    },
    WEBCONFERENCIA: {
        DECLARACAO: {
            caminho: 'webconferencia/declaracao',
            titulo: 'declarações de webconferência',
        },
        CERTIFICADO: {
            caminho: 'webconferencia/certificado',
            titulo: 'certificados de webconferência',
        },
    },
    TFD: {
        caminho: 'tfd',
        titulo: 'Processo de tfd',
    },
    RSE: {
        PROCESSO: {
            caminho: 'rse',
            titulo: 'processo de rse',
        },
        COMPROVACAO: {
            caminho: 'rse/comprovacao-servico',
            titulo: 'comprovação de serviço',
        }
    }
};
